import { Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'
import ExportDatesRange from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportDatesRange'
import ExportEmployeeSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportEmployeeSelector'
import ExportLeaveSelector from 'modules/employees/components/ExportEmployeesModal/ExportFields/ExportLeaveSelector'
import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
  onEmployeeSelectionChange: (selector: EmployeeSelectorV2MultiSelectState) => void
}

const ActivityTimeoffFields = ({ form, onEmployeeSelectionChange }: Props) => {
  const [open, toggle] = useToggle(false)

  const trimDateOptions = [
    {
      label: i18n.t('employees.reports.trim_leave_duration_off'),
      value: false,
    },
    {
      label: i18n.t('employees.reports.trim_leave_duration_on'),
      value: true,
    },
  ]

  return (
    <>
      <ExportEmployeeSelector form={form} onEmployeeSelectionChange={onEmployeeSelectionChange} />
      <ExportLeaveSelector form={form} />
      <ExportDatesRange form={form} />
      <FormRow>
        <Select
          label={i18n.t('employees.reports.trim_leave_duration_label')}
          value={form.get('trim_leave_duration').value}
          secondaryLabel={
            <Tooltip.Alt
              attachment="bottom center"
              open={open}
              toggle={toggle}
              label={i18n.t('employees.reports.trim_leave_duration_help')}
            >
              <Icon.Small icon="question" encircled="grey800" />
            </Tooltip.Alt>
          }
          options={trimDateOptions}
          onChange={(value) => {
            form.setValues({
              trim_leave_duration: value,
            })
          }}
        />
      </FormRow>
    </>
  )
}

export default observer(ActivityTimeoffFields)
